import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { MFASetup as MFASetupComponent } from '@gtintel/signin/components/auth/MFASetup';
import { Button } from '@gtintel/signin/components/common/Button';
import { AuthLayout } from '@gtintel/signin/components/layout/AuthLayout';

export const MFASetup: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [selectedMethod, setSelectedMethod] = useState<'totp' | 'sms' | null>(null);

  const redirectUrl = searchParams.get('redirect') || window.location.origin;

  const handleSuccess = () => {
    // After successful setup, redirect to the original URL
    setTimeout(() => {
      window.location.href = redirectUrl;
    }, 3000);
  };

  const handleCancel = () => {
    setSelectedMethod(null);
  };

  if (!selectedMethod) {
    return (
      <AuthLayout title="Set up Multi-Factor Authentication">
        <div className="space-y-6">
          <p className="text-sm text-gray-600">
            Choose a method to secure your account with multi-factor authentication.
          </p>

          <div className="space-y-3">
            <button
              type="button"
              onClick={() => setSelectedMethod('totp')}
              className="w-full p-4 text-left border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
            >
              <h3 className="font-medium text-gray-900">Authenticator App</h3>
              <p className="mt-1 text-sm text-gray-600">
                Use an app like Google Authenticator or Authy
              </p>
            </button>

            <button
              type="button"
              onClick={() => setSelectedMethod('sms')}
              className="w-full p-4 text-left border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
            >
              <h3 className="font-medium text-gray-900">SMS Text Message</h3>
              <p className="mt-1 text-sm text-gray-600">
                Receive codes via text message to your phone
              </p>
            </button>
          </div>

          <div className="pt-4">
            <Button variant="ghost" fullWidth onClick={() => (window.location.href = redirectUrl)}>
              Skip for now
            </Button>
          </div>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <MFASetupComponent
        method={selectedMethod}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </AuthLayout>
  );
};
